import {
  takeLatest,
  call,
  put,
} from 'redux-saga/effects';
import { Auth } from 'aws-amplify';

import types from '../types';
import actions from '../actions';

import { setUserRegisterApi } from '../../api';

export const getCurrentSession = async () => {
  return Auth.currentSession();
};

export const getAuthUser = async () => {
  return Auth.currentAuthenticatedUser();
};

export function* getUserDataFlow(action) {
  try {
    const {
      data,
    } = action;

    const {
      idToken: {
        jwtToken: token,
      },
    } = yield call(getCurrentSession);

    yield call(setUserRegisterApi, token, data);
  } catch (error) {
    yield put(
      actions.userLoginFailed(error),
    );
  }
}

export function* watchUserRegisterRequested() {
  yield takeLatest(
    types.USER_REGISTER_REQUESTED,
    getUserDataFlow,
  );
}

export default watchUserRegisterRequested;
